import { render, staticRenderFns } from "./ForumList.vue?vue&type=template&id=019f4be8&scoped=true&"
import script from "./ForumList.vue?vue&type=script&lang=js&"
export * from "./ForumList.vue?vue&type=script&lang=js&"
import style0 from "./ForumList.vue?vue&type=style&index=0&id=019f4be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f4be8",
  null
  
)

export default component.exports